import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5DFD3] mt-24 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-3xl">Eko</div>
          <div className="overline mt-1">Cakes & Bakes</div>
          <p className="mt-4 text-sm text-[#6C665F] leading-relaxed">
            Handcrafted cakes, hand-tied blooms and thoughtful hampers delivered pan-India, in a slot that suits you.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/cakes" className="link-underline">Cakes</Link></li>
            <li><Link to="/shop/flowers" className="link-underline">Flowers</Link></li>
            <li><Link to="/shop/hampers" className="link-underline">Hampers</Link></li>
            <li><Link to="/shop/mugs" className="link-underline">Coffee Mugs</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Help</div>
          <ul className="space-y-2 text-sm text-[#6C665F]">
            <li>Delivery Slots</li>
            <li>Pan-India Pincodes</li>
            <li>UPI, Cards & COD</li>
            <li>Contact: hello@ekocakes.in</li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Promise</div>
          <p className="text-sm text-[#6C665F] leading-relaxed">
            Freshly baked, hand-delivered. If it doesn't arrive smiling, neither do we.
          </p>
        </div>
      </div>
      <div className="border-t border-[#E5DFD3] py-6 text-center text-xs text-[#6C665F]">
        © {new Date().getFullYear()} Eko Cakes and Bakes · Made with care in India
      </div>
    </footer>
  );
}
